<script setup lang="tsx">
import { ref } from "vue";
import { Status } from "../../context/context";
import Dialog from "./Dialog.vue";
import IconStatus from "../icon/IconStatus.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Dialog, IconStatus },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    status?: Status;
    content?: string;
    during?: number;
    closeWhenClickOverlay?: boolean;
    dur?: number;
  }>(),
  {
    content: "",
    during: 1500,
    closeWhenClickOverlay: false,
    dur: 200
  }
);

const emits = defineEmits<{
  (event: "open"): void;
  (event: "close"): void;
}>();

const dialog = ref();

function open() {
  dialog.value.open();
  setTimeout(() => {
    close();
  }, props.during);
}

function close() {
  dialog.value.close();
}

defineExpose({
  open,
  close
});
</script>

<template>
  <Dialog
    ref="dialog"
    :showConfirm="false"
    :showTitle="false"
    :closeWhenClickOverlay="props.closeWhenClickOverlay"
    :dur="props.dur"
    minWidth="160px"
    @open="() => emits('open')"
    @close="() => emits('close')"
  >
    <div class="toast">
      <div
        class="icon"
        v-if="props.status"
      >
        <IconStatus
          mode="transparent"
          :status="props.status"
        ></IconStatus>
      </div>
      <div class="content">
        {{ content }}
      </div>
    </div>
  </Dialog>
</template>

<style scoped>
.toast {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1em 1em;
}
.icon {
  margin-bottom: 5px;
  width: 48px;
}
.content {
  font-size: 1em;
}
</style>
